/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Provider } from "~/generated/graphql";
import { ResourceLifecycleDates } from "~/tools";
import { mapMetadata, Metadata } from "../../components";
import { useEstateNidsByProviderDetails } from "../../hooks/useEstateNidsByProviderDetails";
import { useResourceLifeSpanDates } from "../../hooks/useResouceLifeSpanDates";
import { MappedSubnetMetadata } from "../../types";

export function useEc2SubnetDetails(
  metadata: Metadata[],
  resourceLifecycleDates?: ResourceLifecycleDates
) {
  const mapped = mapMetadata<MappedSubnetMetadata>(metadata);

  const { firstSeenDate, lastSeenDate } = useResourceLifeSpanDates({
    lastUpdateDate: mapped.lastUpdateDate,
    resourceLifecycleDates,
  });

  const vpcId = mapped.vpcId ?? "";

  const providerIdToNid = useEstateNidsByProviderDetails(Provider.Aws, [
    { providerId: vpcId, typeSubtype: "ec2/vpc" },
  ]);

  return {
    vpcId,
    vpcNid: providerIdToNid[vpcId] ?? "",
    ipAddress: mapped.availableIpAddressCount ?? "",
    state: mapped.state ?? "",
    cidrBlock: mapped.cidrBlock ?? "",
    availabilityZone: mapped.availabilityZone ?? "",
    owner: mapped.ownerId ?? "",
    firstSeen: firstSeenDate,
    lastSeen: lastSeenDate,
  };
}
